import { routes } from '@/features/v2/constants/routes';

export const core = {
  carousel: [
    {
      title: ' ¡Bonos disponible!',
      description: 'Descubre los bonos disponibles y disfruta sus beneficios.',
      img: '/img/v2/home/gift.webp',
      url: routes.PROMOTIONS,
      comingSoon: true,
    },
    {
      title: 'CONVIERTE EN UN VIP',
      description: 'Siente los beneficios de ser un jugador vip',
      img: '/img/v2/home/crown.webp',
      url: routes.VIP,
      comingSoon: true,
    },
    {
      title: 'JACKPOT SORPRESA',
      description: 'Los Jackpots caen al azar. ¡Juega y gana el tuyo!',
      img: '/img/v2/home/casinoCoin.webp',
      url: routes.JACKPOTS,
      comingSoon: true,
    },
  ],
  title: 'MENÙ',
  menu: [
    {
      title: 'Deportes',
      img: '/img/v2/icons/ball.svg',
      url: routes.SPORTS,
      comingSoon: false,
    },
    {
      title: 'Casino',
      img: '/img/v2/icons/card.webp',
      url: routes.CASINO,
      comingSoon: false,
    },
    {
      title: 'VIP',
      img: '/img/v2/icons/crown.webp',
      url: routes.VIP,
      comingSoon: true,
    },
    {
      title: 'Bonos y Promociones',
      img: '/img/v2/home/gift.webp',
      url: routes.PROMOTIONS,
      comingSoon: true,
    },

    {
      title: 'Torneos',
      img: '/img/v2/icons/trophy.svg',
      url: routes.TOURNAMENTS,
      comingSoon: true,
    },
    {
      title: 'Blog de noticias',
      img: '/img/v2/icons/news.webp',
      url: '/',
      comingSoon: true,
    },
    {
      title: 'Ayuda / Faq',
      img: '/img/v2/icons/ayuda.webp',
      url: `${routes.INFO}/faq`,
      comingSoon: false,
    },
    {
      title: 'Chat en vivo',
      img: '/img/v2/icons/chat.webp',
      url: routes.HOME,
      comingSoon: false,
    },
  ],
};
